<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" v-if="mode === 'new' || mode === 'edit'">
            <validationObserver ref="addDataForm" tag="form">
              <form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset">
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Contact Email</label>
                  <div class="col-lg-4">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Contact Email"
                      :rules="{
                        validateEnglishEmail: true,
                        dynamicRequired: ['กรุณาระบุ Contact Email'],
                      }"
                    >
                      <div class="input-group check-length">
                        <input
                          id="input_contact_email"
                          name="input_contact_email"
                          type="text"
                          class="form-control"
                          placeholder="Contact Email"
                          v-model="model.contact_email"
                          :class="{
                            'is-invalid': errors && errors.length,
                            'is-valid': !(errors && errors.length) && model.contact_email,
                          }"
                        />
                      </div>
                      <div v-if="errors && errors.length" class="validate-invalid">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Apps Namespace</label>
                  <div class="col-lg-4">
                    <div class="input-group check-length">
                      <input
                        id="input_app_namespace"
                        name="input_app_namespace"
                        type="text"
                        class="form-control"
                        placeholder="Apps Namespace Ex. develop, uat, production"
                        v-model="model.app_namespace"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">ชื่อ Apps (อังกฤษ)</label>
                  <div class="col-lg-6">
                    <validationProvider
                      v-slot="{ errors }"
                      name="English Name"
                      :rules="{
                        dynamicRequired: ['กรุณาระบุชื่อ Apps เป็นภาษาอังกฤษ'],
                        duplicateName: [
                          isValidate.display_name,
                          'ชื่อภาษาอังกฤษซ้ำกับข้อมูลที่อยู่ในระบบ',
                        ],
                        validateEnglishSpace: true,
                      }"
                    >
                      <div class="input-group check-length">
                        <div class="input-group-prepend">
                          <div class="input-group-text">EN</div>
                        </div>
                        <input
                          id="input_displayname"
                          name="input_displayname"
                          type="text"
                          class="form-control"
                          placeholder="ระบุชื่อภาษาอังกฤษ"
                          v-model="model.display_name"
                          :class="{
                            'is-invalid': errors && errors.length,
                            'is-valid': !(errors && errors.length) && model.display_name,
                          }"
                          v-on:keyup="onValidateDisplaynameEN($event)"
                        />
                        <!-- <span class="input-validate-length"> {{ model.display_name.length }}/30 </span> -->
                      </div>
                      <div v-if="errors && errors.length" class="validate-invalid">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2"
                    >KeyCloak Client Id (Optional)</label
                  >
                  <div class="col-lg-6">
                    <validationProvider
                      v-slot="{ errors }"
                      name="English Name"
                      :rules="{
                        duplicateName: [
                          isValidate.keycloak_client_id,
                          'KeyCloak Client Id ซ้ำกับข้อมูลที่อยู่ในระบบ',
                        ]
                      }"
                    >
                      <div class="input-group check-length">
                        <input
                          id="input_displayname"
                          name="input_displayname"
                          type="text"
                          class="form-control"
                          placeholder="ระบุ KeyCloak Client Id"
                          v-model="model.keycloak_client_id"
                          :class="{
                            'is-invalid': errors && errors.length,
                            'is-valid':
                              !(errors && errors.length) && model.keycloak_client_id,
                          }"
                          v-on:keyup="onValidateKeyCloakClientId($event)"
                        />
                        <!-- <span class="input-validate-length"> {{ model.display_name.length }}/30 </span> -->
                      </div>
                      <div v-if="errors && errors.length" class="validate-invalid">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">Apps Domains</label>
                  <div class="col-form-label col-lg-8">
                    <div class="row col-lg-12">
                      <div class="col-12" style="padding: 0">
                        <div
                          v-for="(data, index) in app_domains"
                          :key="index"
                          class="inner mb-3 row"
                        >
                          <div class="col-md-10 col-8">
                            <validationProvider
                              :vid="`api_url_${index}`"
                              v-slot="{ errors }"
                              name="Apps Domain"
                            >
                              <!-- :rules="{ required: true, url: true }" -->
                              <input
                                v-model="data.api_url"
                                type="text"
                                class="inner form-control"
                                placeholder="Enter Apps Domain"
                                :class="{
                                  'is-invalid': errors && errors.length,
                                  'is-valid': !(errors && errors.length) && data.api_url,
                                }"
                              />
                              <div
                                v-if="errors && errors.length"
                                class="invalid-feedback"
                              >
                                <span>{{ errors[0] }}</span>
                              </div>
                            </validationProvider>
                          </div>
                          <div class="col-md-2 col-4">
                            <input
                              type="button"
                              class="btn btn-primary btn-block inner"
                              value="Delete"
                              @click="deleteURL(index)"
                            />
                          </div>
                        </div>
                        <input
                          type="button"
                          class="btn btn-success inner"
                          value="Add more URL"
                          @click="addURL"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="mode !== 'new'" class="form-group row mb-4">
                  <label class="col-form-label col-lg-2"> Photo Client Apps </label>
                  <div class="col-lg-8">
                    <div class="row">
                      <div class="col-6">
                        <div class="border p-2 text-center">
                          <template>
                            <img
                              :src="model.photo || require(`@/assets/images/NoImage.jpg`)"
                              class="img-fluid"
                              style="max-height: 200px"
                            />
                            <!-- <p v-if="preview" class="mb-0">file name: {{ image.name }}</p>
              <p v-if="preview" class="mb-0">size: {{ image.size / 1024 }}KB</p> -->
                          </template>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="card bg-dark-grey">
                          <div class="card-body f-12">
                            <div>รายละเอียดรูปภาพ</div>
                            <ul class="mb-0">
                              <li>ใช้นามสกุล .jpg, .jpeg หรือ .png เท่านั้น</li>
                              <li class="image-li">dimension อย่างน้อย 300 x 300 px</li>

                              <li>resolution 300 dpi</li>
                              <li>ขนาดภาพไม่เกิน 3 MB</li>
                              <!-- <li>ความกว้าง และความสูงของรูปต้องเท่ากัน</li> -->
                            </ul>
                          </div>
                        </div>
                        <div>
                          <b-row>
                            <b-col cols="12">
                              <b-progress
                                v-if="imageProgress"
                                value="100"
                                max="100"
                                animated
                              ></b-progress>
                              <b-form-file
                                v-show="!model.photo && !imageProgress"
                                ref="fileInput"
                                placeholder="Choose a image or drop it here..."
                                drop-placeholder="Drop image here..."
                                accept="image/jpg, image/jpeg, image/png"
                                @change="uploadImage"
                              ></b-form-file>
                            </b-col>
                            <b-col cols="6" v-if="model.photo">
                              <b-button
                                block
                                variant="primary"
                                @click="$refs.fileInput.$refs.input.click()"
                              >
                                Change Photo
                              </b-button>
                            </b-col>
                            <b-col cols="6" v-if="model.photo" @click="removeImage">
                              <b-button block> Remove Photo </b-button>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">สถานะ</label>
                  <div class="col-lg-2">
                    <basic-select
                      :options="optionsStatus"
                      :reload="reloadStatusSelector"
                      :selected-option="{
                        text: model.status,
                        value: model.status,
                      }"
                      @select="onStatusSelector($event)"
                      placeholder="ระบุสถานะ"
                      v-bind:isError="isValidate.status"
                    >
                    </basic-select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="text-left">
                      <div class="button-items">
                        <button type="button" class="btn btn-light" @click="onBack()">
                          <i class="bx bx-arrow-back" />
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-right">
                      <div class="button-items">
                        <button type="submit" class="btn btn-primary">
                          <i class="bx bx-save" />Save
                        </button>
                        <button type="reset" class="btn btn-light">
                          <i class="bx bx-reset" />Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </validationObserver>
          </div>
          <div class="card-body" v-if="mode === 'view'">
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right">
                  <button
                    v-show="isShowEditBtn"
                    @click="changeMode('edit')"
                    type="button"
                    class="btn btn-warning waves-effect waves-light"
                  >
                    <i class="mdi mdi-pencil label-icon"></i>
                    Edit Client Apps
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Client Id</label>
              <label class="col-form-label col-lg-8">{{ model.id }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Client Secret</label>
              <label class="col-form-label col-lg-8">{{ model.secret_key }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Apps Name</label>
              <label class="col-form-label col-lg-8">{{ model.display_name }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">KeyCloak Client Id</label>
              <label class="col-form-label col-lg-8">{{
                model.keycloak_client_id
              }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Apps Namespace</label>
              <label class="col-form-label col-lg-8">{{ model.app_namespace }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Contact Email</label>
              <label class="col-form-label col-lg-8">{{ model.contact_email }}</label>
            </div>

            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">App Domains</label>
              <label class="col-form-label col-lg-8">
                <template v-for="(item, index) in model.app_domains">
                  <b-alert show variant="success" v-bind:key="index"
                    ><b>{{ index + 1 }}</b> {{ item }}</b-alert
                  >
                </template>
              </label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">Photo Client Apps</label>
              <label class="col-form-label col-lg-4">
                <div class="border p-2 text-center">
                  <template>
                    <img
                      :src="model.photo || require(`@/assets/images/NoImage.jpg`)"
                      class="img-fluid"
                      style="max-height: 200px"
                    />
                    <!-- <p v-if="preview" class="mb-0">file name: {{ image.name }}</p>
              <p v-if="preview" class="mb-0">size: {{ image.size / 1024 }}KB</p> -->
                  </template>
                </div>
              </label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">สถานะ</label>
              <label class="col-form-label col-lg-8">
                <label :class="`label label-${statusLabel}`">
                  {{ model.status }}
                </label>
              </label>
            </div>

            <div class="form-group mb-4 text-left">
              <div class="button-items">
                <button type="button" class="btn btn-light" @click="onBack()">
                  <i class="bx bx-arrow-back" />
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";

import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import clientAppsService from "@/helpers/service/client-apps-service";
import { eventBus } from "@/main.js";
import { StatusEnum } from "@/enum/status.enum.js";
import { BasicSelect } from "vue-search-select";
import { OptionDropdownStatus } from "@/helpers/utils/status.js";

import filecloudService from "@/helpers/service/filecloud-service";
// import vue2Dropzone from "vue2-dropzone";

export default {
  page: {
    title: "Client Apps Detail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    "basic-select": BasicSelect,
    // vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      id: "",
      title: "View",
      mode: "view",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Client Apps",
          href: "/client-apps",
        },
        {
          text: "View",
          active: true,
        },
      ],
      reloadTypeSelector: false,
      modelOriginal: {},
      model: {
        id: null,
        secret_key: null,
        contact_email: "",
        display_name: "",
        keycloak_client_id: "",
        app_namespace: "develop",
        app_domains: [],
        status: StatusEnum.ACTIVE,
      },
      fields: [{ id: 1, isValidate: { value_en: false, value_th: false } }],
      isValidate: {
        display_name_th: false,
        display_name: false,
        keycloak_client_id: false,
        contact_email: false,
      },
      reloadStatusSelector: false,
      optionsStatus: [],
      messageAlertConfirm: "",
      canUpdateDeleteStatus: {
        isDelete: true,
        isConfirm: "",
      },
      app_domains: [{ id: 1, api_url: "" }],
      image: null,
      imageProgress: false,
    };
  },
  computed: {
    isShowEditBtn() {
      return !(this.model.status === "Delete" || this.model.status === "Pending");
    },
    statusLabel() {
      return this.model !== null && this.model.status !== "" && this.model.status
        ? this.model.status.toLowerCase()
        : "";
    },
  },
  created: function () {
    if (this.$route.params.id == "new") {
      this.mode = "new";
      this.title = "New Client Apps";
      this.items[2].text = "New";

      setTimeout(() => {
        document.title = `New Client Apps | ${appConfig.description}`;
      }, 100);
    } else {
      this.title = "Detail";
      this.items[2].text = "Detail";
      this.id = this.$route.params.id;

      setTimeout(() => {
        document.title = `Edit Detail | ${appConfig.description}`;
      }, 100);
    }
    if (this.$route.query.mode) {
      this.title = "Edit ClientApps";
      this.items[2].text = "Edit";
      this.mode = this.$route.query.mode;
    }
  },
  mounted: function () {
    if (this.mode !== "new") {
      this.optionsStatus = OptionDropdownStatus;
      this.getDetail();
    } else {
      this.optionsStatus = OptionDropdownStatus.filter(
        (s) => s.text !== StatusEnum.DELETE
      );
    }
  },
  methods: {
    async getDetail() {
      const vm = this;
      let result = await clientAppsService.getClientAppAsync(this.id);
      if (result.status === 200) {
        this.model = result.data;
        if (!this.$validate.isValid(this.model.keycloak_client_id)) {
          this.model.keycloak_client_id = ''
        }
        this.modelOriginal = JSON.parse(JSON.stringify(this.model));
        this.app_domains = [];
        result.data.app_domains.forEach((element, index) => {
          vm.app_domains.push({ api_url: element });
        });
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
    },
    onBack() {
      this.$router.push({
        path: "/client-apps",
      });
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(`ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`, "")
        .then((result) => {
          if (result) {
            if (this.mode === "new") {
              this.model = {
                id: null,
                secret_key: null,
                contact_email: "",
                display_name: "",
                keycloak_client_id: "",
                app_namespace: "",
                app_domains: [],
                status: StatusEnum.ACTIVE,
              };
              this.app_domains = [{ id: 1, api_url: "" }];
              this.$nextTick(
                () => this.$refs.addDataForm.reset(),
                this.$refs.addDataForm.$children[0].reset()
              );
              // this.model.display_name = "";
              // this.model.display_name.th = "";
              // this.model.type = "";
              // this.model.status = StatusEnum.ACTIVE;
              // this.model.mdc_code = "";
              // this.reloadTypeSelector = true;
            } else {
              this.getDetail();
            }
          }
        });
    },
    changeMode(_mode) {
      if (_mode == "edit") {
        this.mode = "edit";
        this.title = "Edit";
        this.items[2].text = "Edit";
        this.getDetail();
      }
    },
    async onSubmit() {
      this.isValidate.status = false;
      this.isValidate.type = false;

      if (
        this.model.status === "" ||
        this.model.status === undefined ||
        this.model.status === null
      ) {
        this.isValidate.status = true;
        return;
      }

      if (this.mode === "new") {
        await this.onSaveCreate();
      } else {
        this.$utils
          .confirmAlertDisplay(`ต้องการเปลี่ยนแปลงข้อมูลนี้ใช่หรือไม่`)
          .then(async (result) => {
            if (result) await this.onSave();
          });
      }
    },
    onSave() {
      var vm = this;
      this.$refs.addDataForm.validate().then(async (response) => {
        if (!response) {
          this.$utils.notificationAck(
            "warning",
            "ไม่สามารถดำเนินการได้",
            "กรุณากรอกข้อมูลให้ครบถ้วน"
          );
          return;
        }

        if (response) {
          this.removeLastAndFirstSpacesFromString();
          this.model.app_domains = [];

          vm.app_domains.forEach((element, index) => {
            this.model.app_domains.push(element.api_url);
          });

         // console.log(this.model);
          let result = await clientAppsService.updateClientAppAsync(this.id, this.model);
          if (result.status && result.status === 204) {
            this.$utils.notification("success", "แก้ไขข้อมูลสำเร็จ", 1500);
            this.$router.push({
              path: "/client-apps",
            });
          } else if (
            (result.status && result.status !== 500) ||
            (result.response && result.response.status !== 500)
          ) {
            this.$utils.notification("error", result.response.data.message, 2000);
          }
        }
      });
    },
    async onSaveCreate() {
     // console.log(this.model);
      this.$refs.addDataForm.validate().then(async (response) => {
        if (response) {
          this.removeLastAndFirstSpacesFromString();
          this.model.app_domains = [];
          this.app_domains.forEach((element) => {
            this.model.app_domains.push(element.api_url);
          });

          let result = await clientAppsService.createClientAppAsync(this.model);
          if (result.status === 201) {
            this.$utils.notification("success", "เพิ่มข้อมูลสำเร็จ", 1500);
            this.$router.push({
              path: "/client-apps",
            });
          } else if (
            (result.status && result.status !== 500) ||
            (result.response && result.response.status !== 500)
          ) {
            this.$utils.notificationAck("error", result.response.data.message);
          }
        }
      });
    },
    async onValidateDisplaynameEN() {
      if (this.$validate.isTrimValid(this.model.display_name)) {
        if (
          this.mode === "edit" &&
          this.modelOriginal.display_name.trim() === this.model.display_name.trim()
        ) {
          this.isValidate.display_name = false;
          return;
        }

        let params = new URLSearchParams();
        params.append("clientAppsName", this.model.display_name.trim());

        let result = await clientAppsService.headClientAppAsync(params);
        if (result.status === 200) {
          this.isValidate.display_name = true;
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name = false;
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          if (result.response.data.message) {
            this.$utils.notification("error", result.response.data.message, 2000);
          } else {
            this.$utils.notification("error", "Bad request: Unkonw error", 2000);
          }
        }
      }
    },
    async onValidateKeyCloakClientId() {
      if (this.$validate.isTrimValid(this.model.keycloak_client_id)) {
        if (
          this.mode === "edit" &&
          this.modelOriginal.keycloak_client_id.trim() ===
            this.model.keycloak_client_id.trim()
        ) {
          this.isValidate.keycloak_client_id = false;
          return;
        }

        let params = new URLSearchParams();
        params.append("keycloakClientId", this.model.keycloak_client_id.trim());

        let result = await clientAppsService.headClientAppAsync(params);
        if (result.status === 200) {
          this.isValidate.keycloak_client_id = true;
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.keycloak_client_id = false;
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          if (result.response.data.message) {
            this.$utils.notification("error", result.response.data.message, 2000);
          } else {
            this.$utils.notification("error", "Bad request: Unkonw error", 2000);
          }
        }
      }
    },
    isNotNullOrEmpty(obj) {
      return obj !== undefined && obj !== null && obj !== "";
    },
    isNotNull(obj) {
      return obj !== undefined && obj !== null;
    },
    async onValidateExists(field, index, lang) {
      let value = "";
      if (this.isNotNullOrEmpty(field.value_th) && lang === "th") {
        value = field.value_th;
        field.isValidate.value_th = false;
      }
      if (this.isNotNullOrEmpty(field.value_en) && lang === "en") {
        value = field.value_en;
        field.isValidate.value_en = false;
      }

      if (value !== "") {
        let arrayName = [];

        for (let i = 0; i < this.fields.length; i++) {
          if (index === i) {
            continue;
          }
          if (this.isNotNullOrEmpty(this.fields[i].value_en) && lang === "en")
            arrayName.push(this.fields[i].value_en);
          if (this.isNotNullOrEmpty(this.fields[i].value_th) && lang === "th")
            arrayName.push(this.fields[i].value_th);
        }

        if (arrayName.some((q) => q === value)) {
          if (lang === "th") field.isValidate.value_th = true;
          if (lang === "en") field.isValidate.value_en = true;
        }
      }
    },
    async deleteRow(index) {
      await this.$utils
        .confirmAlertDisplay(`คุณแน่ใจที่จะลบรายการใช่หรือไม่?`, "")
        .then(async (result) => {
          if (result) {
            this.fields.splice(index, 1);
            for (let i = 0; i < this.fields.length; i++) {
              await this.onValidateExists(this.fields[i], i, "th");
              await this.onValidateExists(this.fields[i], i, "en");
            }
          }
        });
    },
    AddformData() {
      this.fields.push({
        value_th: "",
        value_en: "",
        default_value: false,
        isValidate: { value_en: false, value_th: false },
      });
    },
    toggleCheckbox(index) {
      this.fields.forEach((element, i) => {
        if (
          index != i &&
          (element.default_value == "true" || element.default_value == true)
        ) {
          this.fields[i].default_value = false;
        }
      });
    },
    removeLastAndFirstSpacesFromString() {
      this.model.display_name = this.model.display_name.trim();
      this.model.keycloak_client_id = this.model.keycloak_client_id.trim();
      this.model.contact_email = this.model.contact_email.trim();
      this.model.app_namespace = this.model.app_namespace.trim();
    },
    async onStatusSelector(data) {
      this.isValidate.status = false;
      this.reloadStatusSelector = false;

      if (
        data.text === StatusEnum.DELETE &&
        this.canUpdateDeleteStatus.isDelete &&
        this.canUpdateDeleteStatus.isConfirm
      ) {
        this.$utils
          .confirmAlertDisplay(
            `ข้อมูลที่ถูก Delete จะไม่สามารถนำกลับมาใช้งานใหม่ได้ ต้องการ Delete ข้อมูลนี้ใช่หรือไม่`,
            ""
          )
          .then((result) => {
            if (result) this.model.status = data.text ? data.text : "";
          });
      } else if (
        data.text === StatusEnum.DELETE &&
        this.canUpdateDeleteStatus.isDelete &&
        !this.canUpdateDeleteStatus.isConfirm
      ) {
        this.model.status = data.text ? data.text : "";
      } else if (
        data.text === StatusEnum.DELETE &&
        !this.canUpdateDeleteStatus.isDelete
      ) {
        // console.log(
        //   "this.canUpdateDeleteStatus.isDelete",
        //   this.canUpdateDeleteStatus.isDelete
        // );
        this.$utils.notification(
          "warning",
          "มีสินค้าสถานะพร้อมขายอยู่ในนี้ ไม่สามารถปรับสถานะเป็น Delete ได้",
          2000
        );
      } else {
        this.model.status = data.text ? data.text : "";
      }
    },
    addURL() {
      let _id = this.app_domains.length + 1;
      this.app_domains.push({ id: _id, api_url: "" });
    },
    deleteURL(index) {
      this.app_domains.splice(index, 1);
    },
    async uploadImage() {
      this.imageProgress = true;
      const file = event.target.files[0];
      //console.log(file);
      var sp = file.name.split(".");
      var extension = `.${sp[sp.length - 1]}`;
      // var _fname = file.name.replace(extension, '')
      var fileName = `${this.id}${extension}`;
      let dataOriginal = new FormData();
      dataOriginal.append("file", file, fileName);
      dataOriginal.append("bucket", `${process.env.VUE_APP_BUCKET_USER_IMAGE}`);
      dataOriginal.append("path", "clientapps");
      dataOriginal.append("key", fileName);
      dataOriginal.append("content_description", "No Content");
      dataOriginal.append("is_upsert", true);
      let resultUploadOriginal = await filecloudService.uploadImageAsync(dataOriginal);
      this.imageProgress = false;
      if (resultUploadOriginal.status === 201) {
        this.model.photo = resultUploadOriginal.data.content_cdn_url;
      } else {
        this.$utils.notificationConfirm("error", "ไม่สามารถ Upload ไฟล์");
      }
    },
    toSeoUrl(url) {
      // make the url lowercase
      var encodedUrl = url.toString().toLowerCase();

      // replace & with and
      encodedUrl = encodedUrl
        .split(/\&+/) /* eslint-disable-line */
        .join("-and-"); /* eslint-disable-line */

      // remove invalid characters
      encodedUrl = encodedUrl
        .split(/[^a-z0-9]/) /* eslint-disable-line */
        .join("-"); /* eslint-disable-line */

      // remove duplicates
      encodedUrl = encodedUrl.split(/-+/).join("-"); /* eslint-disable-line */

      // trim leading & trailing characters
      encodedUrl = encodedUrl.trim("-");

      return this.toFormatDate(encodedUrl);
    },
    toFormatDate(filename) {
      var nowDate = new Date();
      var exportDate = nowDate.toISOString().replace(/-/g, "").split("T")[0];
      var exportHour = (nowDate.getHours() < 10 ? "0" : "") + nowDate.getHours();
      var exportMinute = (nowDate.getMinutes() < 10 ? "0" : "") + nowDate.getMinutes();
      var exportSeconds = (nowDate.getSeconds() < 10 ? "0" : "") + nowDate.getSeconds();
      var exportFileName =
        filename + "-" + exportDate + "-" + exportHour + exportMinute + exportSeconds;
      return exportFileName.replace("--", "-");
    },
    changeImage() {
     // console.log(this.$refs["fileInput"]);
    },
    removeImage() {
      this.$refs["fileInput"].reset();
      this.model.photo = null;
    },
  },
};
</script>
